import React from 'react';

function LoadMore(props) {
    const {
        currentPage,
        maxPages,
        pageNext,
        pagePrev,

        setCurrentPage,
        scrollUp,
        postsPerPage,
        results,
    } = props;

    function clickHandler() {
        pageNext();
    }

    const remainingPosts = results - postsPerPage * currentPage;

    return (
        <div className="c-btn-wrapper text-center">
            <button
                onClick={() => {
                    clickHandler();
                }}
                disabled={currentPage >= maxPages}
                className="c-btn c-btn-secondary c-btn-color-normal"
            >
                Load More ({remainingPosts})
            </button>
        </div>
    );
}

export default LoadMore;
